import { Alignment } from 'domain/constants/alignment';
import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import { classNames } from '@uds/typography';

const legalCaveat = {
  default: css`
    opacity: 0.9;
    margin-top: ${cssTheme.gu1};
  `,
  centered: css`
    text-align: center;
  `,
};
export default ({ alignment }: { alignment: Alignment }) => {
  return {
    root: css`
      margin-bottom: ${cssTheme.gu2};
    `,
    legalCaveat: cx(legalCaveat.default, alignment === Alignment.CENTER && legalCaveat.centered, classNames.smallprint),
  };
};
